import PropTypes from 'prop-types';
import React from 'react';

import Block from 'components/block';

export default class BlockView extends React.Component {

  /* Render */

  render() {
    const data = this.props.data;
    const blockview = data.map((item) => {
      return (
        <div key={item.id} className="block">
          <Block
            actionHandler={this.props.actionHandler}
            actions={item.actions}
            item={item}
            linkTo={item.linkTo}
            number={item.number}
            onClick={item.onClick}
            price={item.price}
            subtitle={item.subtitle}
            schema={item.schema}
            status={item.status}
            title={item.title}
          />
        </div>
      );
    });

    return (
      <div className="block-view">
        <div className="container">
          <div className="row">
            <div className="block-grid">
              {blockview}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BlockView.propTypes = {
  actionHandler: PropTypes.func,
  data: PropTypes.array,
};



// WEBPACK FOOTER //
// ./js/components/block-view/index.jsx